module.exports = __webpack_public_path__ + "static/img/2.30a6a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20201030/2.png
// module id = kFCV
// module chunks = 1